import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { SaveCategoryModel } from 'src/app/models/catalog/save-category.model';
import { ApiService } from 'src/app/services/api.service';
import { MessageService } from 'src/app/services/message.service';
import { BasePage } from '../base-page';

@Component({
  selector: 'app-filter-sort',
  templateUrl: './filter-sort.component.html',
  styleUrl: './filter-sort.component.scss',
  standalone: false
})
export class FilterSortComponent extends BasePage implements OnInit {

  public items: Item[] = [];

  public category: SaveCategoryModel;


  public constructor(private mApiService: ApiService, private mRouter: Router, activatedRoute: ActivatedRoute, private mMessageService: MessageService) {
    super();

    this.category = {
      id: activatedRoute.snapshot.params['id'],
      isPublished: true
    };

    this.isLoading = true;
  }

  ngOnInit(): void {

    this.mApiService.get<SaveCategoryModel>(`/api/admin/catalog/category/${this.category.id}`).subscribe({
      next: r => {
        this.category = r;
        this.mApiService.get<Item[]>(`/api/admin/category/filter/${this.category.id}`).subscribe({
          next: r => {
            this.items = r;

            for (let i = 0; i < this.items.length; i++) {
              this.items[i].order = i + 1;
            }

            this.isBusy = this.isLoading = false;
          },
          error: () => {
            this.isBusy = this.isLoading = false;
          }
        });
      },
      error: () => this.isLoading = false

    });

  }

  public save() {
    this.isBusy = true;
    this.mApiService.put(`/api/admin/category/filter/${this.category.id}`, this.items).subscribe({
      next: () => {
        this.mMessageService.addMessage({
          type: 'success',
          text: 'Сохранено'
        });
        this.isBusy = false;
      },
      error: () => this.isBusy = false
    });
  }

  public setValue(change: Item, event: any) {

    let newOrder = parseInt(event.target.value);
    if (!(newOrder > 0)) {
      return;
    }

    const maxOrder = Math.max(...this.items.map(i => i.order));

    if (newOrder > maxOrder) {
      newOrder = maxOrder;
    }

    const previewOrder = change.order;

    for (let item of this.items) {
      if (item.order <= newOrder && item.order >= previewOrder) {
        item.order--;
        if (item.order < 1) {
          item.order = 1;
        }
      }
    }

    change.order = newOrder;

    // find same order in items
    let hasSameOrder = false;
    for (let item of this.items) {
      if (item.name !== change.name && item.order == change.order) {
        hasSameOrder = true;
        break;
      }
    }

    if (hasSameOrder) {
      for (let item of this.items) {
        if (item.order >= change.order && item.name != change.name) {
          item.order++;
        }
      }
    }

    this.items = this.items.sort((a, b) => a.order - b.order);

    this.items.forEach((x, index) => { x.order = index + 1 });
  }


}

interface Item {
  name: string;
  order: number;
}
